import { APP_CONFIG } from "../constants/global-variables.js";

export async function getCountries(sportId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajax/countries/${sportId}`;

  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function getCountry(sportId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajax/countries/446`;

  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}
